import type { CallCenterAssistanceViewModel } from './CallCenterAssistanceViewModel'
import { CallOptionTypesDialog } from './CallOptionsDialog'
import { observer } from 'mobx-react-lite'
import { CallSalesRepDialog } from './CallSalesRepDialog'
import type { IconName } from '@/components/Icon'
import { useTranslate } from '@/hooks/translate'

export type CallOptionId = 'CallSalesRep' | 'SelfOnboard'

export interface CallOption {
  id: CallOptionId
  title: string
  description: string
  icon: IconName
  recommended?: boolean
}

interface CallCenterContainerProps {
  vm: CallCenterAssistanceViewModel
}

export const CallAssistanceDialogsContainer = observer(
  ({ vm }: CallCenterContainerProps) => {
    const T = useTranslate()
    const callCenterHours = T(
      'Web.CallCenterHours',
      'Monday - Friday, 9am - 5pm EST',
    )
    return (
      <>
        <CallOptionTypesDialog
          isOpen={vm.callOptionsModalVm.showing}
          onClose={vm.callOptionsModalVm.close}
          isNextDisabled={vm.selectedCallOption === null}
          onNext={() => vm.next()}
          options={vm.assistanceOptions}
          selectOption={vm.selectCallOption}
          activeId={vm.selectedCallOption}
        />
        <CallSalesRepDialog
          isOpen={vm.callSalesRepModalVm.showing}
          onClose={vm.callSalesRepModalVm.close}
          phoneNumber={vm.callCenterNumber}
          callCenterHours={callCenterHours}
        />
      </>
    )
  },
)
